import React, { createContext, useState, useEffect } from 'react';
import { getCurrentUser, signOut } from './cognitoUtils';
import Cookies from 'js-cookie';
import AWS from 'aws-sdk';


export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [s3, setS3] = useState(null);
  const [id_token, setIdToken ] = useState(null);

  const poolData = {
    UserPoolId: process.env.USERPOOL_ID, 
    ClientId: process.env.CLIENT_ID
  };
  const poolId= process.env.POOL_ID

  // useEffect(() => {
  //   const currentUser = getCurrentUser();
  //   if (currentUser) {
  //     currentUser.getSession((err, session) => {
  //       console.log(session)
  //       console.log(session.isValid())
  //       if (!err && session.isValid()) {
  //         console.log(currentUser)
  //         setUser(currentUser); 
  //       } else {
  //         setUser(null); 
  //       }
  //     });
  //   }
  // }, []);

  const initializeSessionFromCookies = () => {
    const idToken_cookie = Cookies.get('idToken'); 
    if (idToken_cookie) {
      const currentUser = getCurrentUser();
      if (currentUser) {
        currentUser.getSession((err, session) => {
          if (!err && session.isValid()) {  
            
            
            const idToken = session.getIdToken().getJwtToken();
            setIdToken(idToken)
            setUser(currentUser);            

            // Configure AWS credentials
            AWS.config.region = 'us-west-2';
            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
              IdentityPoolId: poolId, 
              Logins: {
                [`cognito-idp.us-west-2.amazonaws.com/${poolData.UserPoolId}`]: idToken,
              },
            });

            AWS.config.credentials.clearCachedId();
            AWS.config.credentials.refresh((err) => {
              if (err) {
                console.error('Failed to refresh AWS credentials:', err);
              } else {
                // console.log('AWS credentials successfully refreshed:', AWS.config.credentials);

                const s3Instance = new AWS.S3();
                setS3(s3Instance); 
              }
            });

            const tokenExpiration = session.getIdToken().getExpiration();
            const currentTime = Math.floor(Date.now() / 1000);
            // console.log(tokenExpiration)
            const date = new Date(tokenExpiration * 1000); 
            // console.log(date.toISOString());
            // console.log(currentTime)
            const timeUntilLogout = (tokenExpiration - currentTime) * 1000; 
            // console.log(timeUntilLogout)
            if (timeUntilLogout > 0) {
              setTimeout(() => {
                logout();
              }, timeUntilLogout);
            } else {
              logout();
            }

          } else {
            setUser(null);
            Cookies.remove('idToken'); 
          }
        });
      }
    }
  };

  useEffect(() => {
    initializeSessionFromCookies();
  }, []);

  const logout = () => {
    const currentUser = getCurrentUser();
    if (currentUser) {
      currentUser.signOut();
    }
    setIdToken(null)
    setUser(null);
    Cookies.remove('idToken'); 
  };

  return (
    <AuthContext.Provider value={{ user, id_token, s3, setUser, setIdToken, setS3, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
